import { Suspense } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { LoadingPage } from './components/LoadingPage';
import { Notifications } from './components/Notifications';
import Footer from './components/Footer';
import styles from './Layout.scss';

const Layout = () => {
  const location = useLocation();

  return (
    <div>
      <ScrollRestoration />
      <Notifications />
      <div className={styles.main}>
        <div className="l-main-contents">
          <Suspense key={location.key} fallback={<LoadingPage />}>
            <Outlet />
          </Suspense>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
